import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import AdminDashboard from "./pages/admin/AdminDashboard";
import CoordinatorDashboard from "./pages/coordinator/CoordinatorDashboard";
import StudentDashboard from "./pages/student/StudentDashboard";
import ResearchView from "./pages/ResearchView";
import ResearchList from "./pages/ResearchList";
import TestConnection from "./pages/TestConnection";

export default function App() {
  return (
    <Router>
      <div className="bg-green-950 text-white min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/coordinator" element={<CoordinatorDashboard />} />
          <Route path="/student" element={<StudentDashboard />} />
          <Route path="/research" element={<ResearchList />} />
          <Route path="/research/:id" element={<ResearchView />} />
          <Route path="/test" element={<TestConnection />} />
        </Routes>
      </div>
    </Router>
  );
} 